import { Box, TextField } from "@mui/material";
import { ImPhone } from "react-icons/im";
import CountrySelect from "../Countries/SelectCountry";
import { useCallback } from "react";

export default function MobileField({ formik }) {
  const chooseCountryCode = useCallback(
    (code) => formik.setFieldValue("countryCode", code),
    [formik]
  );
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "background.paper",
        alignItems: "center",
        border: "2px solid #E5E7EB",
      }}
      display="flex"
    >
      <Box
        sx={{
          px: 2,
          borderRight: "2px solid darkgrey",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "text.secondary",
        }}
      >
        <ImPhone size={20} />
      </Box>
      <Box
        sx={{
          width: {
            xl: "20%",
            lg: "20%",
            md: "30%",
            sm: "30%",
            xs: "30%",
          },
          mr: 1,
        }}
      >
        <CountrySelect
          chooseCode={chooseCountryCode}
          error={
            formik.touched.countryCode && Boolean(formik.errors.countryCode)
          }
          helperText={formik.touched.countryCode && formik.errors.countryCode}
          disableBorder
        />
      </Box>
      <TextField
        size="small"
        fullWidth
        id="mobile"
        name="mobile"
        value={formik.values.mobile}
        onChange={formik.handleChange}
        error={formik.touched.mobile && Boolean(formik.errors.mobile)}
        helperText={formik.touched.mobile && formik.errors.mobile}
        placeholder={"Mobile"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
      />
    </Box>
  );
}
